import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function Modal({ open, onClose, title, children }) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-sheet" onClick={e => e.stopPropagation()}>
        <div className="modal-handle" />
        {title && (
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#fff', marginBottom: '20px', marginTop: 0 }}>
            {title}
          </h2>
        )}
        {children}
      </div>
    </div>,
    document.body
  );
}
